// table-row — wireframe skin module (RUN-407: native table redesign)
// Configuration node; host is hidden. Structure rendered by run-table's skin.

export const styles = `
  :host {
    display: none;
  }
`;

export function render(host) {
  host.shadowRoot.innerHTML = `<slot></slot>`;
}
